<div class="modal active">
  <div class="modal__container" [ngClass]="[(activeFieldsConfig || activeChannel1 || activeChannel2 || activeChannel3 || activeChannel4 || activeSot || activeflags)? '' : 'modal__container--md']">
    <div class="fields">
      <h2>Configure Flight Inspection Format</h2>
      <div class="close" (click)="close()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
        <div class="fields__container__tabs">
          <div class="fields__container__tabs__item">
            <a href="#" data-tab="1" (click)="activateFileConfiguration();$event.stopPropagation(); $event.preventDefault()"  [ngClass]="activeFileConfig ? 'active' : ''">File Configuration</a>
            <a href="#" data-tab="1" (click)="activateFieldsConfiguration();$event.stopPropagation(); $event.preventDefault()"  [ngClass]="activeFieldsConfig ? 'active' : ''">
              {{fileFormat != 'Aerodata' ?"Fields Configuration": "Fields" }}
            </a>
            <a *ngIf="fileFormat == 'EDS'" href="#" data-tab="1" (click)="activateSot();$event.stopPropagation(); $event.preventDefault()"  [ngClass]="activeSot ? 'active' : ''">SoT</a>
            <a *ngIf="fileFormat == 'EDS'" href="#" data-tab="1" (click)="activateFlags();$event.stopPropagation(); $event.preventDefault()"  [ngClass]="activeflags ? 'active' : ''">Flags</a>
            <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateChannel1();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeChannel1? 'active' : ''">Channel1</a>
            <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateChannel2();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeChannel2? 'active' : ''">Channel2</a>
            <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateChannel3();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeChannel3? 'active' : ''">Channel3</a>
            <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateChannel4();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeChannel4? 'active' : ''">Channel4</a>
          </div>
        </div>
        <datalist id="my-list">
          <option *ngFor="let navaidString of getNavaidStringOptions()" [value]="navaidString">
        </datalist>
        <form autocomplete="off"  #fieldsConfigForm="ngForm" id="configureImportFlightFields" [ngClass]="[activeFieldsConfig? 'active' : '']">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Fields Definition</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>
                    <caption>
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Name</th>
                        <th scope="col">Units</th>
                        <th scope="col">Index</th>
                        <th scope="col">Style</th>
                      </tr>
                    </thead>
                      <tbody>
                        <tr *ngFor="let el of importConfig?.fieldsConfigurationTable; let i = index">
                          <td>
                            <input id="chk_{{i}}" name="chk_{{i}}"
                            type="checkbox" [(ngModel)]="el.checked" [disabled]="el.required ? true : false"/>
                          </td>
                          <td><input type="text" name="inspectionFieldName_{{i}}" [(ngModel)]="el.name"></td>
                          <td><input type="text" name="inspectionFieldUnits_{{i}}" [(ngModel)]="el.units"></td>
                          <td>
                            <input id="index_{{i}}" required="true"
                            name="index_{{i}}"
                            [(ngModel)]="el.index"/>
                          </td>
                          <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" *ngIf="el.hasStyle" (click)="openStyleOfField(i)">Define</button></div></td>
                        </tr>
                      </tbody>

                    </table>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form autocomplete="off" #fileConfigForm="ngForm" id="configureImportFlightFile" [ngClass]="[activeFileConfig? 'active' : '']" >
          @if (importConfig && importConfig.fileConfiguration) {
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>File Format</h4>
                  <span> </span>
                </div>
                <div class="dropdown-fields">
                  @if (fileFormat != 'Aerodata') {
                    <div>
                      <label for="">Field Separator</label>
                      <select
                          name="fieldSeparator"
                          [(ngModel)]="importConfig.fileConfiguration.fieldSeparator"
                        >
                          <option value=".">Dot (.)</option>
                          <option value=",">Comma (,)</option>
                          <option value=";">Semicolon (;)</option>
                          <option value="\t">Tab</option>
                          <option value=" ">Space</option>
                        </select>
                    </div>
                  }
                </div>
                  <div class="input-fields">
                    <div>
                      <label for="">Data Starting Line</label>
                      <input
                        style="max-width: 112px;"
                        maxlength="5"
                        [(ngModel)]="importConfig.fileConfiguration.dataStartingLine"
                        type="number"
                        name="dataStartingLine"
                        id="dataStartingLine"
                        required="true"
                      />
                    </div>
                  </div>
                  <div class="dropdown-fields">
                    <div>
                      <label for="">Decimal Separator</label>
                      <select
                          name="decimalSeparator"
                          [(ngModel)]="importConfig.fileConfiguration.decimalSeparator"
                        >
                          <option value=".">Dot (.)</option>
                          <option value=",">Comma (,)</option>
                          <option value=";">Semicolon (;)</option>
                        </select>
                    </div>
                  </div>
                  <div class="dropdown-fields">
                    <div>
                      <label for="">Thousand Separator</label>
                      <select
                          name="thousandSeparator"
                          [(ngModel)]="importConfig.fileConfiguration.thousandSeparator"
                          [disabled]="!importConfig?.fileConfiguration.useThousandSeparator"
                        >
                          <option value=".">Dot (.)</option>
                          <option value=",">Comma (,)</option>
                          <option value=";">Semicolon (;)</option>
                        </select>
                    </div>
                  </div>
                  <div>
                    <input name="useThousandSeparator" type="checkbox" [(ngModel)]="importConfig.fileConfiguration.useThousandSeparator" style="margin-right: 5px; top: 1px; position: relative;">
                    <label for="">Use Thousand Separator</label>
                  </div>

              </div>
            </div>
          }
          <div *ngIf="fileFormat == 'EDS' && importConfig != null" class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>NavAid</h4>
                <span> </span>
              </div>
              <input type="text" name="navaidFlightConfig" [(ngModel)]="importConfig.navaid" list="my-list"
               [ngModelOptions]="{ updateOn: 'blur' }" [ngStyle]="{'background-color':!validNavaid(importConfig.navaid)?'red': '' }">
               <span style="color: red;" class="error" *ngIf="!validNavaid(importConfig.navaid)">
                No navaid found with {{importConfig?.navaid}}.
               </span>
            </div>
          </div>
          <div *ngIf="fileFormat == 'EDS' && importConfig != null" class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>MDME Channel</h4>
                <span> </span>
              </div>
              <select name="MDMEChannel" [(ngModel)]="importConfig.mdmeChannel">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
            </div>
          </div>
          <div *ngIf="fileFormat == 'EDS' && importConfig != null" class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Filters</h4>
                <span> </span>
              </div>
              <div>
                <input type="checkbox" name="sotFilters" [(ngModel)]="importConfig.filter.sotFilters" style="margin-right: 5px; top: 1px; position: relative;">
                <label>SoT Filter</label>
              </div>
              <div>
                <input type="checkbox" name="flagFilters" [(ngModel)]="importConfig.filter.flagsFilter" style="margin-right: 5px; top: 1px; position: relative;">
                <label>Flags Filter</label>
              </div>
            </div>

          </div>
          <div *ngIf="fileFormat == 'Aerodata'  && importConfig != null" class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Channels</h4>
                <span> </span>
              </div>
            <div *ngFor="let channel of importConfig.channels;let i = index">
              <input style="margin-right: 5px;" type="checkbox" name="channelcheckbox_{{i}}" [(ngModel)]="channel.checked" >
              <input type="text" name="channelname__{{i}}" [(ngModel)]="channel.channelName"
              [disabled]="!channel.checked" list="my-list" [ngStyle]="{'background-color': !validChannel(channel.channelName)? 'red': ''}">
              <span style="color: red;" class="error" *ngIf="!validChannel(channel.channelName)">
                No navaid found with {{channel.channelName}}.
               </span>
            </div>
          </div>
          </div>
          <p *ngIf="fileFormat == 'Aerodata'" class="note">Note: The Channel field is composed by 'NavAid ID - NavAid Type- NavAid ICAOCC'.</p>
        </form>
        <form autocomplete="off" #ngForm="ngForm" id="configureSoT" [ngClass]="[activeSot? 'active' : '']">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>SoTs</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>

                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Name</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let elem of importConfig?.tableSoT; let i = index">
                        <td>
                          <input type="checkbox" name="UseSOT_{{i}}" [(ngModel)]="elem.selected">
                        </td>
                        <td>{{elem.name}}</td>
                        <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" (click)="editSoTStyle(i)">Define</button></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form autocomplete="off" #flagsForm="ngForm" id="configureFlags" [ngClass]="[activeflags? 'active' : '']">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Flags</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>

                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Flag</th>
                        <th scope="col">Description</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let elem of importConfig?.tableFlags; let i = index">
                        <td>
                          <input type="checkbox" name="UseFlag_{{i}}" [(ngModel)]="elem.selected">
                        </td>
                        <td>
                          <input type="text" [(ngModel)]="elem.flag" name="flagIndex_{{i}}" required>
                        </td>
                        <td>{{elem.description}}</td>
                        <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" (click)="editFlagStyle(i)">Define</button></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form autocomplete="off" #channel1Form="ngForm" id="configureFlags" [ngClass]="[activeChannel1? 'active' : '']">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Channel 1 Fields Definition</h4>
                <span> </span>
              </div>
            <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Name</th>
                        <th scope="col">Units</th>
                        <th scope="col">Index</th>
                        <th scope="col">Style</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let el of importConfig?.channel1;let i = index">
                        <td>
                          <input id="chk_{{i}}" name="chk_{{i}}"
                          type="checkbox" [(ngModel)]="el.checked" [disabled]="el.required ? true : false"/>
                        </td>
                        <td><input type="text" name="inspectionFieldName_{{i}}" [(ngModel)]="el.name"></td>
                        <td><input type="text" name="inspectionFieldUnits_{{i}}" [(ngModel)]="el.units"></td>
                        <td>
                          <input id="index_{{i}}" required="true"
                          name="index_{{i}}"
                          [(ngModel)]="el.index"/>
                        </td>
                        <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" *ngIf="el.hasStyle" (click)="editChannel1Style(i)">Define</button></div></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
            </div>
          </div>
        </form>
        <form autocomplete="off" #channel2Form="ngForm" id="configureFlags" [ngClass]="[activeChannel2? 'active' : '']">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Channel 2 Fields Definition</h4>
                <span> </span>
              </div>
            <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Name</th>
                        <th scope="col">Units</th>
                        <th scope="col">Index</th>
                        <th scope="col">Style</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let el of importConfig?.channel2;let i = index">
                        <td>
                          <input id="chk_{{i}}" name="chk_{{i}}"
                          type="checkbox" [(ngModel)]="el.checked" [disabled]="el.required ? true : false"/>
                        </td>
                        <td><input type="text" name="inspectionFieldName_{{i}}" [(ngModel)]="el.name"></td>
                        <td><input type="text" name="inspectionFieldUnits_{{i}}" [(ngModel)]="el.units"></td>
                        <td>
                          <input id="index_{{i}}" required="true"
                          name="index_{{i}}"
                          [(ngModel)]="el.index"/>
                        </td>
                        <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" *ngIf="el.hasStyle" (click)="editChannel2Style(i)">Define</button></div></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
            </div>
          </div>
        </form>
        <form autocomplete="off" #channel3Form="ngForm" id="configureFlags" [ngClass]="[activeChannel3? 'active' : '']">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Channel 3 Fields Definition</h4>
                <span> </span>
              </div>
            <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Name</th>
                        <th scope="col">Units</th>
                        <th scope="col">Index</th>
                        <th scope="col">Style</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let el of importConfig?.channel3;let i = index">
                        <td>
                          <input id="chk_{{i}}" name="chk_{{i}}"
                          type="checkbox" [(ngModel)]="el.checked" [disabled]="el.required ? true : false"/>
                        </td>
                        <td><input type="text" name="inspectionFieldName_{{i}}" [(ngModel)]="el.name"></td>
                        <td><input type="text" name="inspectionFieldUnits_{{i}}" [(ngModel)]="el.units"></td>
                        <td>
                          <input id="index_{{i}}" required="true"
                          name="index_{{i}}"
                          [(ngModel)]="el.index"/>
                        </td>
                        <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" *ngIf="el.hasStyle" (click)="editChannel3Style(i)">Define</button></div></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
            </div>
          </div>
        </form>
        <form autocomplete="off" #channel4Form="ngForm" id="configureFlags" [ngClass]="[activeChannel4? 'active' : '']">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Channel 4 Fields Definition</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Name</th>
                        <th scope="col">Units</th>
                        <th scope="col">Index</th>
                        <th scope="col">Style</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let el of importConfig?.channel4;let i = index">
                        <td>
                          <input id="chk_{{i}}" name="chk_{{i}}"
                          type="checkbox" [(ngModel)]="el.checked" [disabled]="el.required ? true : false"/>
                        </td>
                        <td><input type="text" name="inspectionFieldName_{{i}}" [(ngModel)]="el.name"></td>
                        <td><input type="text" name="inspectionFieldUnits_{{i}}" [(ngModel)]="el.units"></td>
                        <td>
                          <input id="index_{{i}}" required="true"
                          name="index_{{i}}"
                          [(ngModel)]="el.index"/>
                        </td>
                        <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" *ngIf="el.hasStyle" (click)="editChannel4Style(i)">Define</button></div></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                </div>
            </div>
          </div>
        </form>
        <div class="fields__btn">
          <button *ngIf="importConfig?.fileFormat == 'EDS' "type="submit" [ngClass]="fieldsConfigForm.form.valid && flagsForm.form.valid && validNavaid(importConfig?.navaid)? 'blue' : 'gray'" [disabled]="!fieldsConfigForm.form.valid || !flagsForm.form.valid || !validNavaid(importConfig?.navaid)" (click)="ok()" >
            OK
          </button>
          <button *ngIf="importConfig?.fileFormat == 'Aerodata' "type="submit" [ngClass]="fileConfigForm.form.valid && fieldsConfigForm.form.valid &&
                 channel1Form.form.valid && channel2Form.form.valid && channel3Form.form.valid && channel4Form.form.valid && validChannels()? 'blue' : 'gray'" [disabled]="!fieldsConfigForm.form.valid ||
                 !fileConfigForm.form.valid || !validChannels() || !channel1Form.form.valid  || !channel2Form.form.valid || !channel3Form.form.valid || !channel4Form.form.valid" (click)="ok()" >
            OK
          </button>
          <button *ngIf="importConfig?.fileFormat == 'CSV' "type="submit" [ngClass]="fileConfigForm.form.valid && fieldsConfigForm.form.valid ? 'blue' : 'gray'" [disabled]="!fileConfigForm.form.valid ||!fieldsConfigForm.form.valid" (click)="ok()" >
            OK
          </button>
          <button class="blue" (click)="restoreDefault()">Restore Default</button>
          <button class="gray" (click)="close()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
